import React from "react";
import { FinancialAccount } from "@common/types/financialAccount";
import { FinancialConnection } from "@common/types/financialConnection";
import { IntegrationConnection } from "@common/types/integrationConnection";
import { BrokenConnectionLink } from "@components/financialConnection/BrokenConnectionLink";
import { DisconnectedConnectionMessage } from "@components/financialConnection/DisconnectedConnectionMessage";
import { getIntegrationAccountOfConnection } from "@helpers/financialAccount";
import { useAccountEnablingMutation } from "@mutations/financialAccount";

interface Props {
    account: FinancialAccount;
    connection: FinancialConnection | IntegrationConnection;
}

export const FixConnectionMenuItem: React.FC<Props> = ({
    account,
    connection,
}) => {
    const enableAccount = useAccountEnablingMutation(account);

    return (
        <BrokenConnectionLink
            connection={connection}
            integrationAccount={getIntegrationAccountOfConnection(
                account,
                connection,
            )}
            integrationTriggerVariant="menuItem"
            integrationTriggerLeftIcon={null}
            integrationTriggerTooltip={
                <DisconnectedConnectionMessage connection={connection} />
            }
            onFixed={() => enableAccount.mutate()}
        />
    );
};
